
import { slideToggle, toggleAria } from '../utils.js';
import 'core-js/es/array';

export default class Accordion {

    constructor() {

        this.showBtns = Array.from(document.querySelectorAll('.js-show-hidden-btn'));

        if (this.showBtns) this.init();

    }

    init() {

        this.showBtns.forEach(btn => btn.addEventListener('click', (ev) => {

            const hiddenEl = btn.nextElementSibling;

            btn.classList.toggle('active');
            toggleAria(btn, 'aria-expanded');

            let text;

            if (!hiddenEl) return;

            slideToggle(hiddenEl, 300);

            if (!btn.classList.contains('active')) text = btn.dataset.open;
            else {
                text = btn.dataset.close;
                //setTimeout(() => { hiddenEl.scrollIntoView(); }, 300);
            } 

            btn.textContent = text;

        }));

    }

}